import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeInUp } from './FadeInUp';
const faqs = [{
  question: '¿Es físico o digital?',
  answer: 'Es un producto 100% digital. Inmediatamente después de tu compra, recibirás un correo electrónico con acceso instantáneo al protocolo completo, para que puedas empezar hoy mismo desde tu celular, tablet o computador.'
}, {
  question: '¿Sirve para cualquier raza?',
  answer: 'Sí, absolutamente. El protocolo se basa en los instintos naturales de olfato y resolución de problemas que todos los perros comparten, independientemente de su raza, tamaño o edad.'
}, {
  question: '¿Cómo lo recibo?',
  answer: 'Una vez procesado el pago, el sistema te enviará automáticamente un email con tus credenciales de acceso a nuestra plataforma privada, donde encontrarás todo el material organizado paso a paso.'
}, {
  question: '¿Qué pasa si ya he intentado otros métodos?',
  answer: 'A diferencia de los métodos tradicionales basados en cansancio físico extremo o castigos, nuestro enfoque utiliza estimulación cognitiva. Es un ángulo completamente diferente que suele funcionar en perros donde otras técnicas han fallado.'
}, {
  question: '¿Es un pago mensual?',
  answer: 'NO. Es un pago único y el acceso es de por vida.'
}, {
  question: '¿Tengo que comprar herramientas caras?',
  answer: 'Para nada. Todo lo del protocolo se hace con objetos que ya tienes en casa.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 px-5 max-w-3xl mx-auto pt-[10px] pb-[10px] space-y-[10px]" data-id="element-27">
      <FadeInUp data-id="element-28">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-slate-dark mb-12" data-id="element-29">
          Preguntas Frecuentes
        </h2>
      </FadeInUp>

      <div className="space-y-4" data-id="element-30">
        {faqs.map((faq, index) => <FadeInUp key={index} delay={index * 0.1} data-id="element-31">
            <div className="border border-zen-beige rounded-2xl overflow-hidden bg-white" data-id="element-32">
              <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-33">
                <span className="font-bold text-slate-dark pr-4" data-id="element-34">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-35">
                  <ChevronDownIcon className="w-5 h-5 text-slate-dark/50" data-id="element-36" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-37">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-38">
                    <div className="px-6 pb-5 text-slate-dark/70 leading-relaxed" data-id="element-39">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </FadeInUp>)}
      </div>
    </section>;
}